;(function($){
    $.fn.scrollToProcess = null;
    $.fn.scrollTo = function(delta){
        if (this.length > 0 && $.fn.scrollToProcess == null) {
            if(typeof delta == 'undefined'){
                delta = 0;
            }
            $.fn.scrollToProcess = true;
            $(($.browser.chrome || $.browser.safari) ? 'body, html' : 'html, body')
                .animate(
                    {scrollTop: $(this).offset().top+delta},
                    500,
                    function(){
                        $.fn.scrollToProcess = null;
                    }
                );
        }
        return this; // for chaining...
    };
	$.fn.goTo = function() {
		$('html, body').animate({
			scrollTop: ($(this).offset().top-50) + 'px'
		}, 'fast');
		return this; // for chaining...
	};
	$.fn.scrollBottom = function() {
		$(this).animate({ 
			scrollTop: $(this)[0].scrollHeight
		}, 1000);
		return this; // for chaining...
	};
    $.scrollToUp = function() {
        $('body').scrollTo();
    };
})(jQuery);
